
<div>
    <section *ngIf='totalPosts > 0'>
        <h2 (click)="deletePost(single_post['id'], single_post['gallery'])" class="close">×</h2>
        <h2 class='p_item'>{{single_post["item"]}}</h2>
        <h2 class='p_date'>{{single_post["created_at"] | date:'shortDate'}}</h2>
        <h2 class='p_date_desktop'>{{single_post["created_at"] | date:'longDate'}}</h2>
        <h1 class='p_more' (click)="postShow()" #moreDescription>▼</h1>
    </section>

    <section *ngIf='totalPosts === 0' class='single'>
        <h2 class='p_item'>{{single_post["item"]}}</h2>
    </section>
    
    <button *ngIf='totalPosts > 0' (click)="turnOnEdit(single_post)" class="edit editHidden" #edit>Edit Post</button>
    <div *ngIf='totalPosts > 0' class="post postHidden" #post>
        <h2 class='p_price'>{{single_post["price"] | currency}}</h2>
        <h4 class='p_item'>{{single_post["short_details"]}}</h4>
        <div [innerHTML]="single_post['details']" #post>
    </div>
    
</div>
<div *ngIf="deleted" class="deletePost">
    <h1>Post Deleted!</h1>
</div>
